// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		showSuggestionProductPrice: true,
	}
};

(function () {  
	BoostPFS.inject(this);  

    function hasTag(data, wanted) {
        return (data.tags || []).some(function(tag) {
            return String(tag).trim().toLowerCase() === wanted;
        });
    }

    function isPrixPlancher(data) {
        return hasTag(data, 'promo_type:prix_plancher');
    }

    function hasDisplayMapPrice(data) {
        // window.Theme.rabais_tag is the merchant-configurable alias of
        // 'display_map_price:true' (back-compat, ignored when blank).
        var alias = window.Theme && window.Theme.rabais_tag
            ? String(window.Theme.rabais_tag).trim().toLowerCase()
            : '';
        return hasTag(data, 'display_map_price:true') || (alias !== '' && hasTag(data, alias));
    }

    function showCompareAtOnly(data) {
        return isPrixPlancher(data) && hasDisplayMapPrice(data);
    }

    function buildCompareAtOnlyPrice(data) {
        var value = data.compare_at_price_min;

        // compare_at_price_min is 0 as soon as one variant has no compare-at price.
        if (!(value > 0)) {
            value = data.compare_at_price_max;
        }
        if (!(value > 0)) {
            return '';
        }

        var whole = value.toString().split('.')[0];
        var cents = value.toString().split('.')[1] || '00';
        if (cents.length === 1) cents += '0';

        return '<span class="money">' + whole + '<sup>' + cents + '$</sup></span>';
    }

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
			 if (!suggestionElement) suggestionElement = this.$uiMenuElement;   
		if (!searchElement) searchElement = this.$element;  
		if (!searchBoxId) searchBoxId = this.id; 
	};

	BoostPFS.prototype.beforeBuildSearchBox = function (id) {

		// Remove theme's instant search events
		var cloneSearchBar = jQ(id).clone();
		jQ(id).replaceWith(cloneSearchBar);      
		
		
		if (Utils.InstantSearch.isFullWidthMobile()) {
			jQ(id).removeAttr('autofocus');
			if (jQ(id).is(':focus')) {
				jQ(id).blur();
			}
		}
	};

	BoostPFS.prototype.afterCloseSuggestionMobile = function(searchBoxId, isCloseSearchBox) {
		// Close theme's search pop up
		if (isCloseSearchBox && window.$ && $.fancybox){
			$.fancybox.close(true);
		}
	};
  
  	/* start-boost-custom */
  	SearchInput.prototype._onTypeSearchBoxEvent = function(event) {
		Globals.currentTerm = event.target.value;
        if(Globals.currentTerm.trim().length <= 0){
          jQ('form[action="/search"]').find('input').val('');
          jQ('form[action="/search"]').submit(false);
        }else{
          jQ('form[action="/search"]').submit(true);
        }
	}
    
    InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
      
        // MAP / "prix plancher" + display_map_price:true (mirrors
        // snippets/map-price-flags.liquid): the compare-at price is the ONLY
        // price shown, using the normal price style -- not crossed out.
        if (showCompareAtOnly(this.data)) {
            return buildCompareAtOnlyPrice(this.data);
        }

        if(this.data.price_min > 0){
          // Get UOM from metafields or default
          var uom_master = 'CH.';
          var uom_sat = 'PC.';
          if(Shopify.locale == 'en'){
              uom_master = 'EA.';
          }
          
          // Access metafields from array structure
          var second_price = false;
          var retail_price_sat = null;
          var special_price_sat = null;
          
          if (this.data.metafields && Array.isArray(this.data.metafields)) {
              // Find second_price metafield
              var secondPriceField = this.data.metafields.find(function(m) {
                  return m.namespace === 'custom' && m.key === 'second_price';
              });
              if (secondPriceField && secondPriceField.value === 'true') {
                  second_price = true;
              }
              
              // Find retail_price_sat metafield
              var retailPriceSatField = this.data.metafields.find(function(m) {
                  return m.namespace === 'custom' && m.key === 'retail_price_sat';
              });
              if (retailPriceSatField && retailPriceSatField.value) {
                  retail_price_sat = parseFloat(retailPriceSatField.value);
              }
              
              // Find special_price_sat metafield
              var specialPriceSatField = this.data.metafields.find(function(m) {
                  return m.namespace === 'custom' && m.key === 'special_price_sat';
              });
              if (specialPriceSatField && specialPriceSatField.value) {
                  special_price_sat = parseFloat(specialPriceSatField.value);
              }
              
              // Find uom_master metafield
              var uomMasterField = this.data.metafields.find(function(m) {
                  return m.namespace === 'custom' && m.key === 'uom_master';
              });
              if (uomMasterField && uomMasterField.value) {
                  uom_master = uomMasterField.value.trim().toUpperCase() + '.';
              }
              
              // Find uom_sat metafield
              var uomSatField = this.data.metafields.find(function(m) {
                  return m.namespace === 'custom' && m.key === 'uom_sat';
              });
              if (uomSatField && uomSatField.value) {
                  uom_sat = uomSatField.value.trim().toUpperCase() + '.';
              }
          }
          
          // Check if we should show SAT price instead of regular price
          if (second_price && retail_price_sat) {
              // Show ONLY SAT pricing (no regular price)
              var result = '';
              if (special_price_sat) {
                  // Show crossed out regular SAT price + special SAT price in red
                  var specialSatString = special_price_sat.toString().split('.')[0];
                  var specialSatStringD = special_price_sat.toString().split('.')[1];
                  if (!specialSatStringD) specialSatStringD = '00';
                  
                  var satString = retail_price_sat.toString().split('.')[0];
                  var satStringD = retail_price_sat.toString().split('.')[1];
                  if (!satStringD) satStringD = '00';
                  
                  result = '<s><span class="money">' + satString + '<sup>' + satStringD + '$</sup></span></s> ';
                  result += '<span class="money boost-pfs-search-suggestion-product-sale-price">' + specialSatString + '<sup>' + specialSatStringD + '$</sup></span>';
              } else {
                  // Show regular SAT price
                  var satString = retail_price_sat.toString().split('.')[0];
                  var satStringD = retail_price_sat.toString().split('.')[1];
                  if (!satStringD) satStringD = '00';
                  
                  result = '<span class="money">' + satString + '<sup>' + satStringD + '$</sup></span>';
              }
              // SAT UOM - Translate
              var uom_sat_clean = uom_sat.replace('.', '').trim();
              var uom_sat_translated = uom_sat_clean.toUpperCase() === 'PC' ? 
                  (Shopify.locale === 'en' ? 'sq. ft.' : 'PC.') : 
                  uom_sat_clean;
              result += '<span class="price-ch"> ' + uom_sat_translated + '</span>';
              return result;
          } else {
              // Show regular price + regular UOM
              // Check on sale
              var onSale = this.data.compare_at_price_min > this.data.price_min;
              
              // Format price with dollars and cents separated
              var priceMinString = this.data.price_min.toString().split('.')[0];
              var priceMinStringD = this.data.price_min.toString().split('.')[1];
              if (!priceMinStringD) priceMinStringD = '00';
              
              var result = '';
              if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
                  // Add compare at price first (crossed out)
                  if (this.data.compare_at_price_min) {
                      var compareString = this.data.compare_at_price_min.toString().split('.')[0];
                      var compareStringD = this.data.compare_at_price_min.toString().split('.')[1];
                      if (!compareStringD) compareStringD = '00';
                      result = '<s><span class="money">' + compareString + '<sup>' + compareStringD + '$</sup></span></s> ';
                  }
                  
                  // Show sale price second
                  result += '<span class="money boost-pfs-search-suggestion-product-sale-price">' + priceMinString + '<sup>' + priceMinStringD + '$</sup></span>';
              } else {
                  // Show regular price
                  result = '<span class="money">' + priceMinString + '<sup>' + priceMinStringD + '$</sup></span>';
              }
              
              // Regular UOM - Translate
              var uom_master_clean = uom_master.replace('.', '').trim();
              var uom_master_translated = uom_master_clean.toUpperCase() === 'PC' ? 
                  (Shopify.locale === 'en' ? 'sq. ft.' : 'PC.') : 
                  uom_master_clean;
              result += '<span class="price-ch"> ' + uom_master_translated + '</span>';
              return result;
          }
        }else{
        	return "Contactez votre succursale";
        }
	}
    
    InstantSearchResultItemProduct.prototype.compileTemplate = function() {
		if (this.isShow) {
			var searchTerm = Utils.escape(Globals.currentTerm);
			// Product image
			var imageHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
				imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
				imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
			}
			// Product title
			var productTitle = this.customizeProductTitle();
			productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
          
          	var customTitle = productTitle;
			var en_title = Utils.getProductMetafield(this.data, 'data-en_CA' , 'name_en');
            if(Shopify.locale == 'en' && en_title != undefined){
              customTitle = en_title;
            }

          
			// SKU
			var skuHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
				skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
				skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
			}
			// Vendor
			var vendorHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
				vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
				vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
			}
			// Price
			var priceHTML = this.compileSuggestionProductPrice();
			// Open the result item in new tab when selected
			var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

			return this.getTemplate()
				.replace(/{{id}}/g, this.id)
				.replace(/{{escapedBlockType}}/g, Utils.escape(this.parent.type))
				.replace(/{{url}}/g, this.url)
				.replace(/{{newTabAttribute}}/g, newTabAttr)
				.replace(/{{itemProductImage}}/g, imageHTML)
				.replace(/{{title}}/g, customTitle)
				.replace(/{{escapedTitle}}/g, Utils.escape(customTitle))
				.replace(/{{itemProductSku}}/g, skuHTML)
				.replace(/{{itemProductVendor}}/g, vendorHTML)
				.replace(/{{itemProductPrice}}/, priceHTML)
				.replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
				.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
				.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
		} else {
			return '';
		}
	}

	InstantSearchResultBlock.prototype.compileTemplate = function() {
		if ((this.status != 'active' || !this.isShow) && !this._isShowDYM()) {
			return '';
		}
		var label;

		switch (this.type) {
			case 'suggestions':
				label = Settings.getSettingValue('label.suggestion.instantSearchSuggestionsLabel')
				break;
			case 'collections':
				label = Settings.getSettingValue('label.suggestion.instantSearchCollectionsLabel')
				break;
			case 'products':
				label = Settings.getSettingValue('label.suggestion.instantSearchProductsLabel')
				break;
			case 'pages':
				label = Settings.getSettingValue('label.suggestion.instantSearchPagesLabel')
				break;
			default:
				label = this.isAllEmpty ? this.notFoundLabel : this.label;
				break;
		}
		if (!label) label = this.label;

		return this.getTemplate()
			.replace(/{{type}}/g, this.type)
			.replace(/{{label}}/g, label)
			.replace(/{{class.searchSuggestionHeader}}/g, Class.searchSuggestionHeader)
			.replace(/{{class.searchSuggestionGroup}}/g, Class.searchSuggestionGroup)
			.replace(/{{resultItems}}/g, '');
	}
  	/* end-boost-custom */
})();
